module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-lincoln.8cd4337c.png";